import React from 'react'
import AurBreadcrumb from '../../../common/aur-breadcrumb/AurBreadCrumb';
import {t} from 'i18next';
import { EciHomePageTabs } from '../../../../constants/constants';

const OverlayOverview = () => {
    const breadCrumbItems = [
            {
                label: t('eca.ecaHomepage.coreEciHome'),
                path: `/eci-home-page?tab=${EciHomePageTabs.ECI_OVERVIEW}`,
            },
            {
                label: t('overlay.manageOverlay'),
                path: '/eci-home-page/manage-overlays',
            },
            {
                label: t('overlay.createAnOverlay'),
            },
        ];
  return (
    <AurBreadcrumb items={breadCrumbItems} />
  )
}

export default OverlayOverview